import styled from 'styled-components';

export const Wrapper = styled.div`
    width: calc((100% - 30px)/2);
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
        
    }
`;
export const NavWrapper = styled.ul`
    display: flex;
    align-items: center;
    padding: 20px 15px 15px;
    gap: 15px;
    border: 1px solid #00a0e7;
    flex-wrap: wrap;
    position: relative;
    &::before{
        content: 'STATISTICS';
        position: absolute;
        color: #00a0e7;
        font-weight: bold;
        margin-bottom: 10px;
        background-color: white;
        padding:0 15px;
        font-size: 100%;
        z-index: 1;
        top: 0;
        transform: translateY(-50%);
    }
`;
export const NavItem = styled.li`
    font-size: 15px;
    line-height: 1.5;
    cursor: pointer;
    font-weight: bold;
    letter-spacing: 0;
    color: #777777;
    position: relative;
    transition: all 0.2s ease-in-out;
    &:hover {
        &::after{
            width: 100%;
        } 
    }
    &::after{
        position: absolute;
        content: "";
        bottom: -5px;
        left: 0;
        width: ${props => (props.active ? '100%' : '0')};
        background-color: #00a0e7;
        height: 3px;
        transition: all 0.2s ease-in-out;
    }
`;

export const RecordsSummary = styled.p`
    font-weight: 700;
    color: #0077b3;
    font-size: 100%;
    margin: 20px 0;
    display: flex;
    align-items: center;
    gap: 5px;
`;
export const ClearColor = styled.span`
    color: #777777;
  font-weight: normal;
`
export const StatsWrap = styled.div`
    width: 100%;
    overflow: auto;
`
export const StatsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    
`;
export const TableHeader = styled.tr`
    background-color: #00a0e7;
    color: white;
`;
export const TableRow = styled.tr`
    color: #555;
`;
export const TableMidlRow = styled.tr`
    color: #0077b3;
`
export const TableCell = styled.td`
    font-size: 14px;
    line-height: 1.5;
    padding: 2px 5px 0 5px;
    text-align: ${props => props.align || 'left'}; 
    ${props => props.as === 'th' && `font-weight: bold;`}
    ${props => props.indented && 'padding-left: 30px;'}
`;
